<script lang="ts">
</script>

<div class="herotext">
  <div class="title">
    <img class="visconfig-logo" src="assets/visconfig-logo.svg" alt="visconfig logo">
    <span>v1.0</span>
  </div>
  <div class="cta">
    <p>JSON</p>
    <img class="json-logo" src="assets/json-logo.svg" alt="JSON logo" />
    <span>+</span>
    <p>edit and save!</p>
  </div>
  <p class="desc">
    JSON data visualizer and editor. Upload any JSON and edit it in the dynamic
    form that will be rendered, make your changes and click on the save button
    to export your data. Thanks for trying this small tool!
  </p>
</div>

<style>
  h1 {
    font-weight: 400;
    font-size: 64px;
    line-height: 1;
    margin: 0 12px;
    color: #52525b;
    font-style: italic;
  }

  .visconfig-logo {
    height: 92px;
    width: auto;
  }
  .title {
    display: flex;
  }
  .title span {
    color: #a1a1aa;
  }
  .herotext {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 0.75rem 0 3rem;
  }
  .cta {
    display: flex;
    align-items: center;
  }

  .cta p {
    display: flex;
    font-size: 20px;
    font-weight: 400;
    color: #4f46e5;
    line-height: 20px;
    padding-top: 5px;
  }

  .cta span {
    margin: 0 8px;
    color: #ef4444;
  }

  .herotext .desc {
    font-size: 14px;
    color: #666;
    font-weight: 300;
    margin: 12px 0;
    max-width: 560px;
  }

  .json-logo {
    height: 24px;
    width: 24px;
    margin-left: 4px;
  }
</style>
